<script setup lang="ts">
import { ref } from 'vue';
import SelectButton from 'primevue/selectbutton';
import SvgIcon from '@/components/icons/SvgIcon.vue';
import Env from '@/utils/env';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - This is a temporary solution until vuex is replaced with Pinia
import { useStore } from 'vuex';

const store = useStore();

const value = ref(store.getters.activeViewLayout);
const options = ref([
  { icon: 'layout-grid', value: 'grid' },
  { icon: 'rows3', value: 'list' },
]);

const onUpdateModelValue = (value: string) => {
  store.dispatch('changeActiveViewLayout', {
    activeViewLayout: value,
  });
};
</script>

<template>
  <SelectButton
    v-model="value"
    :allow-empty="false"
    :options="options"
    :pt="{
      pcToggleButton: {
        content: {
          style: {
            padding: Env.getEnv('VITE_THEME') === 'grassfish' ? '7px' : '9px',
          },
        },
      },
    }"
    option-label="value"
    option-value="value"
    data-key="value"
    aria-labelledby="custom"
    @update:model-value="onUpdateModelValue"
    ><template #option="slotProps">
      <SvgIcon :icon="slotProps.option.icon" />
    </template>
  </SelectButton>
</template>

<style scoped lang="scss"></style>
